/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * FINRA Market Data API
 * Market data aggregation backend for FINRA data sources
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DetailNotFoundErrorResponse,
  EquityChartData,
  EquityDetail,
  EquityPriceSummary,
  Filings,
  GetEquityChartParams,
  HTTPValidationError,
  InternalErrorResponse,
  UpstreamAuthenticationFailedErrorResponse,
  UpstreamBadGatewayErrorResponse,
  UpstreamNotFoundErrorResponse,
  UpstreamUnavailableErrorResponse,
  WrongInvestmentTypeErrorResponse
} from '../fINRAMarketDataAPI.schemas.ts';

import { apiFetch } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getEquityDetailResponse200 = {
  data: EquityDetail
  status: 200
}

export type getEquityDetailResponse404 = {
  data: DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse
  status: 404
}

export type getEquityDetailResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getEquityDetailResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityDetailResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityDetailResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityDetailResponseSuccess = (getEquityDetailResponse200) & {
  headers: Headers;
};
export type getEquityDetailResponseError = (getEquityDetailResponse404 | getEquityDetailResponse422 | getEquityDetailResponse500 | getEquityDetailResponse502 | getEquityDetailResponse503) & {
  headers: Headers;
};

export type getEquityDetailResponse = (getEquityDetailResponseSuccess | getEquityDetailResponseError)

export const getGetEquityDetailUrl = (symbol: string,) => {




  return `/api/v1/equity/${symbol}/detail`
}

/**
 * Get the full equity detail page response for a given symbol.
 *
 * Aggregates data from Morningstar Investment Details and Market Data APIs
 * into a structured response for the equity detail page.
 *
 * Args:
 *     symbol: The equity trading symbol (e.g., "AAPL", "MSFT")
 *     morningstar: Injected MorningstarClient instance
 *     morningstar_market_data: Injected MorningstarMarketDataClient instance
 *
 * Returns:
 *     EquityDetail containing overview, performance, top fund holders, and related info.
 *     Chart data and filings are served by separate lazy-loaded endpoints.
 *     CMS content is not included in this response.
 *
 * Raises:
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Equity Detail
 */
export const getEquityDetail = async (symbol: string, options?: RequestInit): Promise<getEquityDetailResponse> => {

  return apiFetch<getEquityDetailResponse>(getGetEquityDetailUrl(symbol),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityDetailQueryKey = (symbol: string,) => {
    return [
    `/api/v1/equity/${symbol}/detail`
    ] as const;
    }


export const getGetEquityDetailQueryOptions = <TData = Awaited<ReturnType<typeof getEquityDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityDetailQueryKey(symbol);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityDetail>>> = ({ signal }) => getEquityDetail(symbol, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityDetail>>>
export type GetEquityDetailQueryError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityDetail<TData = Awaited<ReturnType<typeof getEquityDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityDetail>>,
          TError,
          Awaited<ReturnType<typeof getEquityDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityDetail<TData = Awaited<ReturnType<typeof getEquityDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityDetail>>,
          TError,
          Awaited<ReturnType<typeof getEquityDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityDetail<TData = Awaited<ReturnType<typeof getEquityDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Detail
 */

export function useGetEquityDetail<TData = Awaited<ReturnType<typeof getEquityDetail>>, TError = DetailNotFoundErrorResponse | WrongInvestmentTypeErrorResponse | UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityDetail>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityDetailQueryOptions(symbol,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEquityChartResponse200 = {
  data: EquityChartData
  status: 200
}

export type getEquityChartResponse404 = {
  data: UpstreamNotFoundErrorResponse
  status: 404
}

export type getEquityChartResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getEquityChartResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityChartResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityChartResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityChartResponseSuccess = (getEquityChartResponse200) & {
  headers: Headers;
};
export type getEquityChartResponseError = (getEquityChartResponse404 | getEquityChartResponse422 | getEquityChartResponse500 | getEquityChartResponse502 | getEquityChartResponse503) & {
  headers: Headers;
};

export type getEquityChartResponse = (getEquityChartResponseSuccess | getEquityChartResponseError)

export const getGetEquityChartUrl = (symbol: string,
    params: GetEquityChartParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/equity/${symbol}/chart?${stringifiedParams}` : `/api/v1/equity/${symbol}/chart`
}

/**
 * Get historical OHLCV chart data for an equity. Lazy-loaded by the detail page.
 *
 * Args:
 *     symbol: The equity trading symbol (e.g., "AAPL", "MSFT")
 *     morningstar: Injected MorningstarMarketDataClient instance
 *     start_date: Start of date range in DD-MM-YYYY format (e.g., "01-01-2025")
 *     end_date: End of date range in DD-MM-YYYY format (e.g., "31-12-2025")
 *
 * Returns:
 *     EquityChartData wrapping the Morningstar time-series response
 *
 * Raises:
 *     404: Symbol not found in Morningstar
 *     500: Morningstar API error or authentication failure
 * @summary Get Equity Chart
 */
export const getEquityChart = async (symbol: string,
    params: GetEquityChartParams, options?: RequestInit): Promise<getEquityChartResponse> => {

  return apiFetch<getEquityChartResponse>(getGetEquityChartUrl(symbol,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityChartQueryKey = (symbol: string,
    params?: GetEquityChartParams,) => {
    return [
    `/api/v1/equity/${symbol}/chart`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEquityChartQueryOptions = <TData = Awaited<ReturnType<typeof getEquityChart>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string,
    params: GetEquityChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityChartQueryKey(symbol,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityChart>>> = ({ signal }) => getEquityChart(symbol,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityChartQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityChart>>>
export type GetEquityChartQueryError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityChart<TData = Awaited<ReturnType<typeof getEquityChart>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetEquityChartParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityChart>>,
          TError,
          Awaited<ReturnType<typeof getEquityChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityChart<TData = Awaited<ReturnType<typeof getEquityChart>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetEquityChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityChart>>,
          TError,
          Awaited<ReturnType<typeof getEquityChart>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityChart<TData = Awaited<ReturnType<typeof getEquityChart>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetEquityChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Chart
 */

export function useGetEquityChart<TData = Awaited<ReturnType<typeof getEquityChart>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string,
    params: GetEquityChartParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityChart>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityChartQueryOptions(symbol,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse200 = {
  data: Filings
  status: 200
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse404 = {
  data: UpstreamNotFoundErrorResponse
  status: 404
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponseSuccess = (getEquityFilingsApiV1EquitySymbolFilingsGetResponse200) & {
  headers: Headers;
};
export type getEquityFilingsApiV1EquitySymbolFilingsGetResponseError = (getEquityFilingsApiV1EquitySymbolFilingsGetResponse404 | getEquityFilingsApiV1EquitySymbolFilingsGetResponse422 | getEquityFilingsApiV1EquitySymbolFilingsGetResponse500 | getEquityFilingsApiV1EquitySymbolFilingsGetResponse502 | getEquityFilingsApiV1EquitySymbolFilingsGetResponse503) & {
  headers: Headers;
};

export type getEquityFilingsApiV1EquitySymbolFilingsGetResponse = (getEquityFilingsApiV1EquitySymbolFilingsGetResponseSuccess | getEquityFilingsApiV1EquitySymbolFilingsGetResponseError)

export const getGetEquityFilingsApiV1EquitySymbolFilingsGetUrl = (symbol: string,) => {




  return `/api/v1/equity/${symbol}/filings`
}

/**
 * Get SEC EDGAR filings for an equity, grouped by category. Lazy-loaded by the detail page.
 *
 * The CIK used to query EDGAR is read from Morningstar's equity-basic-reference
 * response (companyInformation.cik) rather than looked up via SEC's ticker file,
 * since Morningstar maintains that mapping independently, including for OTC symbols.
 *
 * Args:
 *     symbol: The equity trading symbol (e.g., "AAPL", "MSFT")
 *
 * Returns:
 *     Filings grouped into financials, announcements, ownership, offering statements,
 *     insider activities, and other categories.
 *
 * Raises:
 *     404: Symbol not found
 *     500: EDGAR API error
 * @summary Get Equity Filings
 */
export const getEquityFilingsApiV1EquitySymbolFilingsGet = async (symbol: string, options?: RequestInit): Promise<getEquityFilingsApiV1EquitySymbolFilingsGetResponse> => {

  return apiFetch<getEquityFilingsApiV1EquitySymbolFilingsGetResponse>(getGetEquityFilingsApiV1EquitySymbolFilingsGetUrl(symbol),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityFilingsApiV1EquitySymbolFilingsGetQueryKey = (symbol: string,) => {
    return [
    `/api/v1/equity/${symbol}/filings`
    ] as const;
    }


export const getGetEquityFilingsApiV1EquitySymbolFilingsGetQueryOptions = <TData = Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityFilingsApiV1EquitySymbolFilingsGetQueryKey(symbol);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>> = ({ signal }) => getEquityFilingsApiV1EquitySymbolFilingsGet(symbol, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityFilingsApiV1EquitySymbolFilingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>>
export type GetEquityFilingsApiV1EquitySymbolFilingsGetQueryError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityFilingsApiV1EquitySymbolFilingsGet<TData = Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>,
          TError,
          Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityFilingsApiV1EquitySymbolFilingsGet<TData = Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>,
          TError,
          Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityFilingsApiV1EquitySymbolFilingsGet<TData = Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Filings
 */

export function useGetEquityFilingsApiV1EquitySymbolFilingsGet<TData = Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityFilingsApiV1EquitySymbolFilingsGet>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityFilingsApiV1EquitySymbolFilingsGetQueryOptions(symbol,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEquityPriceSummaryResponse200 = {
  data: EquityPriceSummary
  status: 200
}

export type getEquityPriceSummaryResponse404 = {
  data: UpstreamNotFoundErrorResponse
  status: 404
}

export type getEquityPriceSummaryResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getEquityPriceSummaryResponse500 = {
  data: UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse
  status: 500
}

export type getEquityPriceSummaryResponse502 = {
  data: UpstreamBadGatewayErrorResponse
  status: 502
}

export type getEquityPriceSummaryResponse503 = {
  data: UpstreamUnavailableErrorResponse
  status: 503
}

export type getEquityPriceSummaryResponseSuccess = (getEquityPriceSummaryResponse200) & {
  headers: Headers;
};
export type getEquityPriceSummaryResponseError = (getEquityPriceSummaryResponse404 | getEquityPriceSummaryResponse422 | getEquityPriceSummaryResponse500 | getEquityPriceSummaryResponse502 | getEquityPriceSummaryResponse503) & {
  headers: Headers;
};

export type getEquityPriceSummaryResponse = (getEquityPriceSummaryResponseSuccess | getEquityPriceSummaryResponseError)

export const getGetEquityPriceSummaryUrl = (symbol: string,) => {




  return `/api/v1/equity/${symbol}/price-summary`
}

/**
 * Get a lightweight price + 5-year price change summary for an equity.
 *
 * Used by homepage content (e.g. a news item referencing a security ticker)
 * to show live price data without loading the full equity detail page.
 * Only queries the Market Data API, so it also works for ETF tickers.
 *
 * Args:
 *     symbol: The equity trading symbol (e.g., "AAPL", "MSFT")
 *     morningstar: Injected MorningstarMarketDataClient instance
 *
 * Returns:
 *     EquityPriceSummary with current price and 5-year price change
 *
 * Raises:
 *     404: Symbol not found in Morningstar (no quote data returned)
 *     500: Morningstar API error or authentication failure
 * @summary Get Equity Price Summary
 */
export const getEquityPriceSummary = async (symbol: string, options?: RequestInit): Promise<getEquityPriceSummaryResponse> => {

  return apiFetch<getEquityPriceSummaryResponse>(getGetEquityPriceSummaryUrl(symbol),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEquityPriceSummaryQueryKey = (symbol: string,) => {
    return [
    `/api/v1/equity/${symbol}/price-summary`
    ] as const;
    }


export const getGetEquityPriceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getEquityPriceSummary>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquityPriceSummaryQueryKey(symbol);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquityPriceSummary>>> = ({ signal }) => getEquityPriceSummary(symbol, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: symbol !== null && symbol !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquityPriceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getEquityPriceSummary>>>
export type GetEquityPriceSummaryQueryError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse


export function useGetEquityPriceSummary<TData = Awaited<ReturnType<typeof getEquityPriceSummary>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityPriceSummary>>,
          TError,
          Awaited<ReturnType<typeof getEquityPriceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityPriceSummary<TData = Awaited<ReturnType<typeof getEquityPriceSummary>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquityPriceSummary>>,
          TError,
          Awaited<ReturnType<typeof getEquityPriceSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquityPriceSummary<TData = Awaited<ReturnType<typeof getEquityPriceSummary>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Equity Price Summary
 */

export function useGetEquityPriceSummary<TData = Awaited<ReturnType<typeof getEquityPriceSummary>>, TError = UpstreamNotFoundErrorResponse | HTTPValidationError | UpstreamAuthenticationFailedErrorResponse | InternalErrorResponse | UpstreamBadGatewayErrorResponse | UpstreamUnavailableErrorResponse>(
 symbol: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquityPriceSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquityPriceSummaryQueryOptions(symbol,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






